<form class="f-col blank-form">
  <div class="section-heading">
    <h2 class="h2-heading">{{content?.['b2b.managepolicy.pctitle']}}</h2>
  </div>

  <div class="section-content" [formGroup]="policyCriteriaCopyForm">
    <div class="inner-contentsection">
      <h4 class="subheading">{{content?.['b2b.managepolicy.travelpolicyflight']}}</h4>
      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col" formGroupName="jouneryRule">
            <label class="mat-label">{{content?.['b2b.managepolicy.journeyrule']}}</label>
            <div class="f-row mat-check-group" [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'">
              <mat-checkbox class="checkbox-wrapper"
                formControlName="OW">{{content?.['b2b.managepolicy.oneway']}}</mat-checkbox>
              <mat-checkbox class="checkbox-wrapper"
                formControlName="RT">{{content?.['b2b.managepolicy.roundtrip']}}</mat-checkbox>
              <mat-checkbox class="checkbox-wrapper"
                formControlName="MCT">{{content?.['b2b.managepolicy.multidest']}}</mat-checkbox>
            </div>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('jouneryRule')?.hasError('required') && policyCriteriaCopyForm.get('jouneryRule')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.journeyrulerequired'] || 'Journey Rule is required.'}}</mat-error>
          </div>
        </div>
      </div>
      <div class="f-row" formArrayName="policyCriteria">
        <div class="policy-criteria-rows-iterator">
          <div class="policy-criteria-rows"
            *ngFor="let policy of policyCriteriaControls; let policyIndex = index; let policyFirst = first"
            [formGroupName]="policyIndex">
            <div class="condition-block">{{policyFirst?'IF':'AND'}}</div>
            <div class="field-block">
              <ng-select [placeholder]="content?.['b2b.managepolicy.selectkey']" formControlName="key" bindLabel="name"
                bindValue="name"
                [disabled]="policyCriteriaControls.at(policyIndex)?.get('key')?.value && policyCriteriaControls.at(policyIndex)?.get('value')?.value"
                [style.pointer-events]="policyCriteriaControls.at(policyIndex)?.get('key')?.value && policyCriteriaControls.at(policyIndex)?.get('value')?.value ? 'none' : 'auto'"
                (change)="policyKey($event,true,policyIndex,false)">
                <ng-container *ngFor="let policy of commonApiLists.travelPolicyCriterial">
                  <ng-option [value]="policy.name" [disabled]="policy.isSelected"
                    [ngClass]="{ 'disabled': policy.isSelected }">
                    {{policy.name}}
                  </ng-option>
                </ng-container>
              </ng-select>
              <mat-error class="px-4" *ngIf="
                  policyCriteriaControls.at(policyIndex)?.hasError('keyValuePairRequired')
                  && !policyCriteriaControls.at(policyIndex)?.get('key')?.value
                  && (policyCriteriaControls.at(policyIndex)?.get('key')?.touched || policyCriteriaControls.at(policyIndex)?.get('value')?.touched)
                ">
                {{dictionaryContent?.['b2b.managepolicy.selectakey'] || 'Please select a key.'}}
              </mat-error>
            </div>
            <div class="division-block"><mat-icon fontSet="material-symbols-outlined">drag_handle</mat-icon></div>
            <button type="button" class="button-as-div field-block"
              (click)="policyKey(policy.value.key,true,policyIndex,true)">
              <mat-form-field class="pointer-events">
                <mat-label>{{content?.['b2b.managepolicy.selectvalue']}}</mat-label>
                <input matInput formControlName="value" />
                <mat-error *ngIf="
                    policyCriteriaControls.at(policyIndex)?.hasError('keyValuePairRequired')
                    && !policyCriteriaControls.at(policyIndex)?.get('value')?.value
                    && (policyCriteriaControls.at(policyIndex)?.get('key')?.touched || policyCriteriaControls.at(policyIndex)?.get('value')?.touched)
                  ">
                  {{dictionaryContent?.['b2b.global.selectavalue'] || 'Please select a value.'}}
                </mat-error>
              </mat-form-field>
            </button>
            <div class="action-block">
              <a class="onclick-cell primary-link"
                *ngIf="policyCriteriaControls?.at(policyIndex)?.get('key')?.value && policyCriteriaControls?.at(policyIndex)?.get('value')?.value"
                (click)="policyKey(policy.value.key,true,policyIndex,true)">
                <mat-icon fontSet="material-symbols-outlined"> edit </mat-icon>
              </a>
              <a class="onclick-cell warm-link"
                *ngIf="policyCriteriaControls?.at(policyIndex)?.get('key')?.value && policyCriteriaControls?.at(policyIndex)?.get('value')?.value"
                (click)="remove(policy,policyIndex)">
                <mat-icon fontSet="material-symbols-outlined"> delete </mat-icon>
              </a>
              <a class="onclick-cell info-link"
                *ngIf="[PolicyCriteriaTypes.Airline,PolicyCriteriaTypes.Origin,PolicyCriteriaTypes.Destination].includes(policy.value.key) && isViewVisible(policy.value.key)"
                (click)="view(policy.value,policyIndex)">
                <mat-icon fontSet="material-symbols-outlined"> visibility </mat-icon>
              </a>
            </div>
          </div>
          <a class="add-link-field" [class.disabled]="isAddPolicyDisabled"
            *ngIf="policyCriteriaControls.length !== commonApiLists.travelPolicyCriterial.length"
            (click)="createPolicyCriteria()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon>
            {{content?.['b2b.managepolicy.addnewpc']}} </a>
        </div>
      </div>
    </div>
    <div class="inner-contentsection">
      <h4 class="subheading">{{content?.['b2b.managepolicy.permittedcabinclasses'] || 'Permitted cabin classes'}}</h4>
      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <label class="mat-label" for="">{{content?.['b2b.managepolicy.class']}}</label>
            <div class="f-row mat-check-group" [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'">
              <mat-checkbox class="checkbox-wrapper"
                formControlName="IsEconomy">{{content?.['b2b.managepolicy.guest']}}</mat-checkbox>
              <mat-checkbox class="checkbox-wrapper"
                formControlName="IsBusiness">{{content?.['b2b.managepolicy.business']}}</mat-checkbox>
              <mat-checkbox class="checkbox-wrapper"
                formControlName="IsFirst">{{content?.['b2b.managepolicy.upgradecabincatlist']?.[1]?.Phrase ||
                'First'}}</mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-contentsection">
      <h4 class="subheading">{{content?.['b2b.managepolicy.generalinfo']}}<div class="dot">.</div> <span
          class="optional">{{content?.['b2b.managepolicy.optional'] || 'Optional'}}</span></h4>
      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.managepolicy.outofpolicy']}}</mat-label>
            <input matInput formControlName="outPolicyReasion" (keypress)="outOfPolicyReasonBlockInvalid($event)" />
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('outPolicyReasion')?.hasError('required') && policyCriteriaCopyForm.get('outPolicyReasion')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.outofpolicyreasonreq'] || 'Out of Policy Reason is
              required.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('outPolicyReasion')?.hasError('minlength') && policyCriteriaCopyForm.get('outPolicyReasion')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.reasonminlimit'] || 'Reason must be at least 5 characters
              long.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('outPolicyReasion')?.hasError('maxlength') && policyCriteriaCopyForm.get('outPolicyReasion')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.reasonminlimit'] || 'Reason must not exceed 250
              characters.'}}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.managepolicy.maxtrip']}}</mat-label>
            <input matInput formControlName="maxTripStayDays" (keypress)="validateDays($event, 'maxTripStayDays')" />
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('maxTripStayDays')?.hasError('required') && policyCriteriaCopyForm.get('maxTripStayDays')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.tripstaydays'] || 'Max Trip Stays Days is required.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('maxTripStayDays')?.errors?.['pattern'] && policyCriteriaCopyForm.get('maxTripStayDays')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.tripstaydaysnumber'] || 'Max Trip Stays Days must be a
              number.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('maxTripStayDays')?.hasError('minlength') && policyCriteriaCopyForm.get('maxTripStayDays')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.valueminlimit'] || 'Value must be at least 1 day.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('maxTripStayDays')?.hasError('maxlength') && policyCriteriaCopyForm.get('maxTripStayDays')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.valuemaxlimit'] || 'Value must not exceed 365 days.'}}</mat-error>
          </mat-form-field>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.managepolicy.bookingdate']}}</mat-label>
            <input matInput formControlName="beforeTripStart" (keypress)="validateDays($event, 'beforeTripStart')" />
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('beforeTripStart')?.hasError('required') && policyCriteriaCopyForm.get('beforeTripStart')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.bookingdaterequired'] || 'Booking Date Before Trip Start is
              required.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('beforeTripStart')?.errors?.['pattern'] && policyCriteriaCopyForm.get('beforeTripStart')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.bookingdatenumber'] || 'Booking Date Before Trip Start must be a
              number.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('beforeTripStart')?.hasError('minlength') && policyCriteriaCopyForm.get('beforeTripStart')?.touched">{{dictionaryContent?.['b2b.managepolicy.valueminlimit']
              || 'Value must be at least 1 day.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('beforeTripStart')?.hasError('maxlength') && policyCriteriaCopyForm.get('beforeTripStart')?.touched">{{dictionaryContent?.['b2b.managepolicy.valuemaxlimit']
              || 'Value must not exceed 365 days.'}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="inner-contentsection">
      <h4 class="subheading">{{content?.['b2b.managepolicy.faretolerance']}}<div class="dot">.</div> <span
          class="optional">{{content?.['b2b.managepolicy.faretolerance'] || 'Optional'}}</span></h4>
      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.managepolicy.domestic']}}</mat-label>
            <input matInput formControlName="fareToleranceDomestic" (keypress)="fareTollaranceValidation($event)"
              maxlength="100">
          </mat-form-field>
          <mat-error
            *ngIf="policyCriteriaCopyForm.get('fareToleranceDomestic')?.hasError('required') && policyCriteriaCopyForm.get('fareToleranceDomestic')?.touched">
            {{dictionaryContent?.['b2b.managepolicy.domesticrequired'] || 'Domestic is required.'}}</mat-error>
          <mat-error
            *ngIf="policyCriteriaCopyForm.get('fareToleranceDomestic')?.hasError('maxlength') && policyCriteriaCopyForm.get('fareToleranceDomestic')?.touched">
            {{dictionaryContent?.['b2b.managepolicy.domesticfaretolerance'] || 'Domestic fare tolerence value cannot
            exceed 100.'}}</mat-error>
          <div class="f-row mat-check-group checkbox-under-field">
            <mat-checkbox class="checkbox-wrapper"
              formControlName="fareToleranceDomesticPercentage">{{content?.['b2b.managepolicy.inpercentage']}}</mat-checkbox>
          </div>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.managepolicy.international']}}</mat-label>
            <input matInput formControlName="fareToleranceInternational" (keypress)="fareTollaranceValidation($event)"
              maxlength="100" />
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('fareToleranceInternational')?.hasError('required') && policyCriteriaCopyForm.get('fareToleranceInternational')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.internationalrequired'] || 'International is
              required.'}}</mat-error>
            <mat-error
              *ngIf="policyCriteriaCopyForm.get('fareToleranceInternational')?.hasError('maxlength') && policyCriteriaCopyForm.get('fareToleranceInternational')?.touched">
              {{dictionaryContent?.['b2b.managepolicy.internationalfaretolerance'] || 'International fare tolerence
              value cannot exceed 100.'}}</mat-error>

          </mat-form-field>
          <div class="f-row mat-check-group checkbox-under-field">
            <mat-checkbox class="checkbox-wrapper"
              formControlName="fareToleranceInternationalPercentage">{{content?.['b2b.managepolicy.inpercentage']}}</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <mat-slide-toggle
              formControlName="nonRefundable">{{content?.['b2b.managepolicy.allowbooking']}}</mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-action">
      <button mat-button class="button--secondary-small" type="button"
        (click)="navigateToList()">{{content?.['b2b.managepolicy.cancel']}}</button>
      <button mat-button class="button--primary-small" (click)="saveForm()"
        [class.disabled]="policyCriteriaCopyForm.invalid" [disabled]="commonObj.isSubmitting">
        {{content?.['b2b.managepolicy.saveandnext']}}
        <ng-container *ngIf="commonObj.isSubmitting">
          <mat-spinner class="button"></mat-spinner>
        </ng-container>
      </button>
    </div>
  </div>
</form>
<ng-template appNgTemplateRef="MarketTypeModel">
  <div class="custom-popup-gen-container" [formGroup]="popupsForm">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.selectmarket']}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
        aria-label="close button" (keyup.space)="onCriteriaPopupClose()" (keydown.enter)="onCriteriaPopupClose()"
        (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <div class="custom-label-group-radios">
        <label class="mat-label" for="">{{content?.['b2b.managepolicy.type']}}</label>
        <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="MarketType">
          <mat-radio-button [value]="'DOM'">{{content?.['b2b.managepolicy.domestic']}}</mat-radio-button>
          <mat-radio-button [value]="'INT'">{{content?.['b2b.managepolicy.international']}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button
        (click)="savePopup('MarketTypeModel',popupsForm.value.MarketType)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="AirlineModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.setairlinecriteria'] || 'Set Airline Criteria'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
        aria-label="close button" (keyup.space)="onCriteriaPopupClose()" (keydown.enter)="onCriteriaPopupClose()"
        (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body vh-minus-height">
      <div class="custom-search-container">
        <mat-icon fontSet="material-symbols-outlined">search</mat-icon>
        <input type="text"
          [placeholder]="content?.['b2b.managepolicy.searchselectairline'] || 'Search and Select Airline'"
          (input)="searchAirlineFilter($event)">
      </div>
      <div class="custom-label-search-container">
        <ng-container *ngFor="let airline of commonApiLists.airlineCriteria">
          <button *ngIf="airline.isVisible" [class.selected]="airline.isSelected"
            (click)="airlineChange(airline)"><span>{{airline.AirlineName}}</span><mat-icon
              fontSet="material-symbols-outlined" *ngIf="airline.isSelected">check</mat-icon></button>
        </ng-container>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button [class.disabled]="!hasSelectedAirline()"
        [disabled]="!hasSelectedAirline()"
        (click)="airlineSave(false);savePopup('AirlineModel',popupsForm.value.AirlineCriteria)">
        {{content?.['b2b.managepolicy.save']}}
      </button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="OriginModel">
  <div class="custom-popup-gen-container" [formGroup]="popupsForm">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.setorigincriteria'] || 'Set departure cities'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
        aria-label="close button" (keyup.space)="onCriteriaPopupClose()" (keydown.enter)="onCriteriaPopupClose()"
        (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body" formGroupName="origin">
      <div class="custom-label-group-radios">
        <label class="mat-label">{{content?.['b2b.managepolicy.type']}}</label>
        <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="setFor"
          (change)="reset(PolicyCriteriaTypes.Origin)">
          <mat-radio-button *ngFor="let set of commonApiLists.originSetFor" [value]="set">{{set}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container [ngSwitch]="popupsForm.value.origin.setFor.toLowerCase()">
        <div class="section-content">
          <div class="inner-contentsection vh-minus-height-overflow-auto">
            <ng-container *ngSwitchCase="'region'">
              <div class="f-row">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="commonApiLists.originRegion" class="custom-ng-multiple-chip"
                    formControlName="region" bindValue="Region_name" bindLabel="Region_name"
                    [placeholder]="content?.['b2b.managepolicy.selectregion'] || 'Select Region'" [multiple]="true"
                    [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="row">
                        <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                          [ngModelOptions]="{standalone: true}"> {{item.Region_name}}</mat-checkbox>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'zone'">
              <!-- Zone selection UI removed (zone dropdowns are not used anymore). -->
            </ng-container>
            <ng-container *ngSwitchCase="'country'">
              <ng-container formArrayName="addCountry">
                <ng-container
                  *ngFor="let addCountry of getAnotherCountriesControl;let addCountryIndex = index;let addCountryFirst = first"
                  [formGroupName]="addCountryIndex">
                  <span class="hr" *ngIf="!addCountryFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addCountryFirst">
                    {{content?.['b2b.managepolicy.addanothercountry'] || 'Add another country'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.originCountry[addCountryIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="country" bindValue="CountryCode"
                        bindLabel="CountryName"
                        [placeholder]="content?.['b2b.managepolicy.selectcountry'] || 'Select Country'"
                        (change)="getDropdowns('check_country',addCountryIndex)" [multiple]="true"
                        [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CountryName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'city'">
              <ng-container formArrayName="addCity">
                <ng-container
                  *ngFor="let addCity of getAnotherCitiesControl;let addCityIndex = index;let addCityFirst = first"
                  [formGroupName]="addCityIndex">
                  <span class="hr" *ngIf="!addCityFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addCityFirst">
                    {{content?.['b2b.managepolicy.addanothercity'] || 'Add another city'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select [items]="commonApiLists.dropdowns.originCountry[addCityIndex].pipe || []"
                        formControlName="country" bindValue="CountryCode" bindLabel="CountryName"
                        (change)="getDropdowns('city_country',addCityIndex)"
                        [placeholder]="content?.['b2b.managepolicy.selectcountry'] || 'Select Country'"
                        [appendTo]="'body'"> </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect [items]="commonApiLists.dropdowns.originCity[addCityIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="city"
                        [placeholder]="content?.['b2b.managepolicy.selectcity'] || 'Select City'" bindValue="CityCode"
                        bindLabel="CityName" (change)="commonApiUniqueListsAssigner('check_city',addCityIndex)"
                        [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CityName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
                <a class="add-link-field" [class.disabled]="popupsForm.get('origin.addCity')?.invalid"
                  (click)="addCityGroup()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                  {{content?.['b2b.managepolicy.addnew'] || 'Add new'}}</a>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'airport'">
              <ng-container formArrayName="addAirport">
                <ng-container
                  *ngFor="let addCountry of getAnotherAirportControl;let addAirportIndex = index;let addAirportFirst = first"
                  [formGroupName]="addAirportIndex">
                  <span class="hr" *ngIf="!addAirportFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addAirportFirst">
                    {{content?.['b2b.managepolicy.addanotherairport'] || 'Add another airport'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select [items]="commonApiLists.dropdowns.originCountry[addAirportIndex].pipe || []"
                        formControlName="country" bindValue="CountryCode" bindLabel="CountryName"
                        (change)="getDropdowns('airport_country',addAirportIndex)"
                        [placeholder]="content?.['b2b.managepolicy.addanotherairport'] || 'Select Country'"
                        [appendTo]="'body'"> </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.originCity[addAirportIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="city"
                        (change)="getDropdowns('airport_city',addAirportIndex)"
                        [placeholder]="content?.['b2b.managepolicy.selectcity'] || 'Select City'" bindValue="CityCode"
                        bindLabel="CityName" [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                        [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CityName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.originAirport[addAirportIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="airport" bindValue="AirportCode"
                        bindLabel="AirportName"
                        [placeholder]="content?.['b2b.managepolicy.selectcity'] || 'Select Airport'"
                        (change)="commonApiUniqueListsAssigner('check_airport', addAirportIndex)" [multiple]="true"
                        [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.AirportName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
                <a class="add-link-field" [class.disabled]="popupsForm.get('origin.addAirport')?.invalid"
                  (click)="addAirportGroup()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                  {{content?.['b2b.managepolicy.addnew'] || 'Add new'}}</a>
              </ng-container>
            </ng-container>
            <div class="custom-label-group-radios">
              <label class="mat-label">{{content?.['b2b.managepolicy.inpolicy'] || 'In Policy :'}}</label>
              <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="inPolicy">
                <mat-radio-button value="Allowed">{{content?.['b2b.managepolicy.allowed'] ||
                  'Allowed'}}</mat-radio-button>
                <mat-radio-button value="Restricted">{{content?.['b2b.managepolicy.restricted'] ||
                  'Restricted'}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="policy-criteria-row-btn">
      <button class="button--secondary-small" mat-button
        (click)="resetOriginDestination(PolicyCriteriaTypes.Origin)">{{content?.['b2b.managepolicy.clear'] ||
        'Clear'}}</button>
      <button class="button--primary-small" mat-button
        [class.disabled]="popupsForm.get('origin')?.get(commonApiLists.originSetForController[popupsForm.value.origin.setFor])?.invalid"
        (click)="savePopup('OriginModel',popupsForm.value.origin,true,false)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="DestinationModel">
  <div class="custom-popup-gen-container" [formGroup]="popupsForm">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.allowed'] || 'Allowed'}}Set Destination Criteria</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
        aria-label="close button" (keyup.space)="onCriteriaPopupClose()" (keydown.enter)="onCriteriaPopupClose()"
        (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body" formGroupName="destination">
      <div class="custom-label-group-radios">
        <label class="mat-label">{{content?.['b2b.managepolicy.type']}}</label>
        <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="setFor"
          (change)="reset(PolicyCriteriaTypes.Destination)">
          <mat-radio-button *ngFor="let set of commonApiLists.originSetFor" [value]="set">{{set}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container [ngSwitch]="popupsForm.value.destination.setFor.toLowerCase()">
        <div class="section-content">
          <div class="inner-contentsection vh-minus-height-overflow-auto">
            <ng-container *ngSwitchCase="'region'">
              <div class="f-row">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="commonApiLists.originRegion" class="custom-ng-multiple-chip"
                    formControlName="region" bindValue="Region_name" bindLabel="Region_name"
                    [placeholder]="content?.['b2b.managepolicy.selectregion'] || 'Select Region'" [multiple]="true"
                    [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="row">
                        <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                          [ngModelOptions]="{standalone: true}"> {{item.Region_name}}</mat-checkbox>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'zone'">
              <!-- Zone selection UI removed (zone dropdowns are not used anymore). -->
            </ng-container>
            <ng-container *ngSwitchCase="'country'">
              <ng-container formArrayName="addCountry">
                <ng-container
                  *ngFor="let addCountry of getAnotherCountriesControl;let addCountryIndex = index;let addCountryFirst = first"
                  [formGroupName]="addCountryIndex">
                  <span class="hr" *ngIf="!addCountryFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addCountryFirst">
                    {{content?.['b2b.managepolicy.addanothercountry'] || 'Add another country'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.destinationCountry[addCountryIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="country" bindValue="CountryCode"
                        bindLabel="CountryName" [placeholder]="content?.['b2b.managepolicy.selectcountry'] || 'Select Country'"
                        (change)="getDropdowns('check_country',addCountryIndex)" [multiple]="true"
                        [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CountryName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
                <!-- <a class="add-link-field" (click)="addCountryGroup()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon> Add new</a> -->
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'city'">
              <ng-container formArrayName="addCity">
                <ng-container
                  *ngFor="let addCity of getAnotherCitiesControl;let addCityIndex = index;let addCityFirst = first"
                  [formGroupName]="addCityIndex">
                  <span class="hr" *ngIf="!addCityFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addCityFirst">
                    {{content?.['b2b.managepolicy.addanothercity'] || 'Add another city'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select [items]="commonApiLists.dropdowns.destinationCountry[addCityIndex].pipe || []"
                        formControlName="country" bindValue="CountryCode" bindLabel="CountryName"
                        (change)="getDropdowns('city_country',addCityIndex)"
                        [placeholder]="content?.['b2b.managepolicy.selectcountry'] || 'Select Country'"
                        [appendTo]="'body'"> </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.destinationCity[addCityIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="city"
                        [placeholder]="content?.['b2b.managepolicy.selectcity'] || 'Select City'" bindValue="CityCode"
                        bindLabel="CityName" (change)="commonApiUniqueListsAssigner('check_city', addCityIndex)"
                        [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CityName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
                <a tabindex="0" role="button" class="add-link-field" (keydown.enter)="addCityGroup()"
                  (click)="addCityGroup()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                  {{content?.['b2b.managepolicy.addnew'] || 'Add new'}}</a>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'airport'">
              <ng-container formArrayName="addAirport">
                <ng-container
                  *ngFor="let addCountry of getAnotherAirportControl;let addAirportIndex = index;let addAirportFirst = first"
                  [formGroupName]="addAirportIndex">
                  <span class="hr" *ngIf="!addAirportFirst"></span>
                  <p class="custom-popup-gen-heading" *ngIf="!addAirportFirst">
                    {{content?.['b2b.managepolicy.addanotherairport'] || 'Add another airport'}}</p>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select [items]="commonApiLists.dropdowns.destinationCountry[addAirportIndex].pipe || []"
                        formControlName="country" bindValue="CountryCode" bindLabel="CountryName"
                        (change)="getDropdowns('airport_country',addAirportIndex)"
                        [placeholder]="content?.['b2b.managepolicy.selectcountry'] || 'Select Country'"
                        [appendTo]="'body'"> </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.destinationCity[addAirportIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="city"
                        (change)="getDropdowns('airport_city',addAirportIndex)"
                        [placeholder]="content?.['b2b.managepolicy.selectcity'] || 'Select City'" bindValue="CityCode"
                        bindLabel="CityName" [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                        [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.CityName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="f-row">
                    <div class="f-col">
                      <ng-select autoBlurSelect
                        [items]="commonApiLists.dropdowns.destinationAirport[addAirportIndex].pipe || []"
                        class="custom-ng-multiple-chip" formControlName="airport" bindValue="AirportCode"
                        bindLabel="AirportName"
                        [placeholder]="content?.['b2b.managepolicy.selectairport'] || 'Select Airport'"
                        (change)="commonApiUniqueListsAssigner('check_airport', addAirportIndex)" [multiple]="true"
                        [closeOnSelect]="false" [clearSearchOnAdd]="true" [appendTo]="'body'">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <div class="row">
                            <mat-checkbox class="checkbox-wrapper" id="item-{{index}}" [ngModel]="item$.selected"
                              [ngModelOptions]="{standalone: true}"> {{item.AirportName}}</mat-checkbox>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
                <a tabindex="0" role="button" class="add-link-field" (keydown.enter)="addAirportGroup()"
                  (click)="addAirportGroup()"><mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                  {{content?.['b2b.managepolicy.addnew'] || 'Add new'}}</a>
              </ng-container>
            </ng-container>
            <div class="custom-label-group-radios">
              <label class="mat-label">{{content?.['b2b.managepolicy.inpolicy'] || 'In Policy :'}}</label>
              <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="inPolicy">
                <mat-radio-button value="Allowed">{{content?.['b2b.managepolicy.allowed'] ||
                  'Allowed'}}</mat-radio-button>
                <mat-radio-button value="Restricted">{{content?.['b2b.managepolicy.restricted'] ||
                  'Restricted'}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="policy-criteria-row-btn">
      <button class="button--secondary-small" mat-button
        (click)="resetOriginDestination(PolicyCriteriaTypes.Destination)">{{content?.['b2b.managepolicy.clear'] ||
        'Clear'}}</button>
      <button class="button--primary-small" mat-button
        [class.disabled]="popupsForm.get('destination')?.get(commonApiLists.originSetForController[popupsForm.value.destination.setFor])?.invalid"
        (click)="savePopup('DestinationModel',popupsForm.value.destination,true,false)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="CostRangeModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.costrange'] || 'Cost Range'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body" [formGroup]="popupsForm">
      <div class="section-content" formGroupName="costRange">
        <div class="inner-contentsection">
          <div class="f-row two--ColLayout">
            <div class="f-col">
              <mat-form-field>
                <mat-label>{{content?.['b2b.managepolicy.from'] || 'From'}}</mat-label>
                <input matInput formControlName="from" />
                <mat-error
                  *ngIf="popupsForm.get('costRange.from')?.hasError('required') && popupsForm.get('costRange.from')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.costrangerequired'] || 'Cost range from is
                  required.'}}</mat-error>
                <mat-error
                  *ngIf="popupsForm.get('costRange.from')?.errors?.['pattern'] && popupsForm.get('costRange.from')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.costrangenumber'] || 'Cost range from must be a
                  number.'}}</mat-error>
              </mat-form-field>
            </div>
            <div class="f-col">
              <mat-form-field>
                <mat-label>{{content?.['b2b.managepolicy.to'] || 'To'}}</mat-label>
                <input matInput formControlName="to" />
                <mat-error
                  *ngIf="popupsForm.get('costRange.to')?.hasError('required') && popupsForm.get('costRange.to')?.touched">
                  {{content?.['b2b.managepolicy.costrangerequired'] || 'Cost range to is required.'}}</mat-error>
                <mat-error
                  *ngIf="popupsForm.get('costRange.to')?.errors?.['pattern'] && popupsForm.get('costRange.to')?.touched">
                  {{content?.['b2b.managepolicy.costrangenumber'] || 'Cost range to must be a number.'}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button [class.disabled]="popupsForm.get('costRange')?.invalid"
        (click)="savePopup('CostRangeModel',popupsForm.value.costRange)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="BookingDateModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.bookingdaterange'] || 'Booking Date Range'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <div class="section-content">
        <div class="inner-contentsection" [formGroup]="popupsForm">
          <div class="f-row two--ColLayout" formGroupName="booking">
            <div class="f-col position-relative open-calendar-bottom">
              <mat-form-field appearance="fill"
                (click)="showComponent('isBookFromCalendar');removeAddValidator('booking.from','remove')">
                <mat-label>{{content?.['b2b.managepolicy.from'] || 'From'}}</mat-label>
                <input matInput formControlName="from" readonly="true"
                  [placeholder]="content?.['b2b.managepolicy.selectfrom'] || 'Select from'" autocomplete="off"
                  (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                  (paste)="_CommonService.pasteControlHTMLTags($event)" />
                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                <mat-error
                  *ngIf="popupsForm.get('booking.from')?.hasError('required') && popupsForm.get('booking.from')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.selectfrom'] || 'Please select from.'}} </mat-error>
              </mat-form-field>
              <app-expiry-data-calendar *ngIf="isChildVisible['isBookFromCalendar']" [AddOnMonths]="0"
                [minimumDate]="commonObj.minDate" [filledDate]="popupsForm.value.booking.from"
                [passengerTravelerCode]="'ADT'" (confirm)="onConfirm('isBookFromCalendar')"
                (dateSelected)="onDateSelected($event,'isBookFromCalendar','booking','from')">
              </app-expiry-data-calendar>
            </div>
            <div class="f-col position-relative c-position-right open-calendar-bottom">
              <mat-form-field appearance="fill"
                (click)="showComponent('isBookToCalendar');removeAddValidator('booking.to','remove')">
                <mat-label>{{content?.['b2b.managepolicy.to'] || 'To'}}</mat-label>
                <input matInput formControlName="to" readonly="true"
                  [placeholder]="content?.['b2b.managepolicy.to'] || 'Select To'" autocomplete="off"
                  (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                  (paste)="_CommonService.pasteControlHTMLTags($event)" />
                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                <mat-error
                  *ngIf="popupsForm.get('booking.to')?.hasError('required') && popupsForm.get('booking.to')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.selectto'] || 'Please select to.'}} </mat-error>
              </mat-form-field>
              <app-expiry-data-calendar *ngIf="isChildVisible['isBookToCalendar']" [AddOnMonths]="0"
                [minimumDate]="popupsForm.value.booking.from" [filledDate]="popupsForm.value.booking.to"
                [passengerTravelerCode]="'ADT'" (confirm)="onConfirm('isBookToCalendar')"
                (dateSelected)="onDateSelected($event,'isBookToCalendar','booking','to')"> </app-expiry-data-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button [class.disabled]="popupsForm.get('booking')?.invalid"
        (click)="savePopup('BookingDateModel',popupsForm.value.booking)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="TripDateModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.tridaterange'] || 'Trip Date Range'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <div class="section-content">
        <div class="inner-contentsection" [formGroup]="popupsForm">
          <div class="f-row two--ColLayout" formGroupName="trip">
            <div class="f-col position-relative open-calendar-bottom">
              <mat-form-field appearance="fill"
                (click)="showComponent('isBookTripFromCalendar');removeAddValidator('trip.from','remove')">
                <mat-label>{{content?.['b2b.managepolicy.from'] || 'From'}}</mat-label>
                <input matInput formControlName="from" readonly="true"
                  [placeholder]="content?.['b2b.managepolicy.selectfrom'] || 'Select from'" autocomplete="off"
                  (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                  (paste)="_CommonService.pasteControlHTMLTags($event)" />
                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                <mat-error
                  *ngIf="popupsForm.get('trip.from')?.hasError('required') && popupsForm.get('trip.from')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.selectfrom'] || 'Please select from.'}} </mat-error>
              </mat-form-field>
              <app-expiry-data-calendar *ngIf="isChildVisible['isBookTripFromCalendar']" [AddOnMonths]="0"
                [minimumDate]="commonObj.minDate" [filledDate]="popupsForm.value.trip.from"
                [passengerTravelerCode]="'ADT'" (confirm)="onConfirm('isBookTripFromCalendar')"
                (dateSelected)="onDateSelected($event,'isBookTripFromCalendar','trip','from')">
              </app-expiry-data-calendar>
            </div>
            <div class="f-col position-relative c-position-right open-calendar-bottom">
              <mat-form-field appearance="fill"
                (click)="showComponent('isBookTripToCalendar');removeAddValidator('trip.to','remove')">
                <mat-label>{{content?.['b2b.managepolicy.to'] || 'To'}}</mat-label>
                <input matInput formControlName="to" readonly="true"
                  [placeholder]="content?.['b2b.managepolicy.selectto'] || 'Select To'" autocomplete="off"
                  (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                  (paste)="_CommonService.pasteControlHTMLTags($event)" />
                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                <mat-error
                  *ngIf="popupsForm.get('trip.to')?.hasError('required') && popupsForm.get('trip.to')?.touched">
                  {{dictionaryContent?.['b2b.managepolicy.selectto'] || 'Please select to.'}} </mat-error>
              </mat-form-field>
              <app-expiry-data-calendar *ngIf="isChildVisible['isBookTripToCalendar']" [AddOnMonths]="0"
                [minimumDate]="popupsForm.value.trip.from" [filledDate]="popupsForm.value.trip.to"
                [passengerTravelerCode]="'ADT'" (confirm)="onConfirm('isBookTripToCalendar')"
                (dateSelected)="onDateSelected($event,'isBookTripToCalendar','trip','to')"> </app-expiry-data-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button [class.disabled]="popupsForm.get('trip')?.invalid"
        (click)="savePopup('TripDateModel',popupsForm.value.trip)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="NoOfStopsModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.selectstops'] || 'Select No. of Stops'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body" [formGroup]="popupsForm">
      <div class="custom-label-group-radios">
        <label class="mat-label">{{content?.['b2b.managepolicy.selectstops'] || 'Select No. of Stops'}} :</label>
        <div class="f-row mat-check-group">
          <mat-radio-group [aria-label]="content?.['b2b.managepolicy.selectoption'] || 'Select an option'" formControlName="NumberofStops">
            <mat-radio-button *ngFor="let stop of commonApiLists.noOfStops"
              [value]="stop.bindValue">{{stop.bindLabel}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <p class="custom-popup-gen-text">Note: {{commonApiLists.noOfStopsNote[popupsForm.value.NumberofStops]}}</p>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button
        (click)="savePopup('NoOfStopsModel',popupsForm.value.NumberofStops)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template appNgTemplateRef="LayoverDurationModel">
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.layoverduration'] || 'Layover Duration'}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="onCriteriaPopupClose()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body gap-0" [formGroup]="popupsForm">
      <div class="custom-label-group-radios pd-border-0" formGroupName="Layover">
        <label class="mat-label">{{content?.['b2b.managepolicy.maximumlayover'] || 'Maximum Layover :'}} </label>
        <div class="f-row mat-check-group align-items">
          <mat-form-field class="width-min-width-80">
            <mat-label>{{content?.['b2b.managepolicy.hh'] || 'HH'}}</mat-label>
            <input matInput formControlName="hh">
          </mat-form-field>
          <mat-form-field class="width-min-width-80">
            <mat-label>{{content?.['b2b.managepolicy.mm'] || 'MM'}}</mat-label>
            <input matInput formControlName="mm">
          </mat-form-field>
          <label class="mat-label">{{content?.['b2b.managepolicy.hours'] || 'Hrs.'}}</label>
        </div>
      </div>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.hh')?.hasError('required') && popupsForm.get('Layover.hh')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.hourrequired'] || 'Hour is required.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.hh')?.errors?.['min'] && popupsForm.get('Layover.hh')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.minlimit'] || 'Hour must be at least 0.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.hh')?.errors?.['max'] && popupsForm.get('Layover.hh')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.hourmaxlimit'] || 'Hour cannot be more than 23.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.hh')?.errors?.['pattern'] && popupsForm.get('Layover.hh')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.hournumber'] || 'Hour must be a number.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.mm')?.hasError('required') && popupsForm.get('Layover.mm')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.minuterequired'] || 'Minute is required.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.mm')?.errors?.['min'] && popupsForm.get('Layover.mm')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.minuteminlimit'] || 'Minute must be at least 0.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.mm')?.errors?.['max'] && popupsForm.get('Layover.mm')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.minutemaxlimit'] || 'Minute cannot be more than 59.'}}</mat-error>
      <mat-error class="mat-error"
        *ngIf="popupsForm.get('Layover.mm')?.errors?.['pattern'] && popupsForm.get('Layover.mm')?.touched">
        {{dictionaryContent?.['b2b.managepolicy.minutenumber'] || 'Minute must be a number.'}}</mat-error>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button [class.disabled]="popupsForm.get('Layover')?.invalid"
        (click)="savePopup('LayoverDurationModel',popupsForm.value.Layover)">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>
<ng-template #ViewAirlineModel>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managepolicy.view'] || 'View'}} {{commonObj.viewTableHeading}} Criteria</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
        aria-label="close button" (keyup.space)="policyMatDialogRef.close()"
        (keydown.enter)="policyMatDialogRef.close()" (click)="policyMatDialogRef.close()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <div class="custom-view-table">
        <div class="custom-view-table-head">
          <span *ngFor="let key of commonObj.viewTableHead">{{key}}</span>
        </div>
        <div class="custom-view-table-body">
          <div class="custom-view-table-row" *ngFor="let value of commonObj.viewTableRows">
            <span>{{value.AirlineCode}}</span>
            <span>{{value.AirlineName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button
        (click)="policyMatDialogRef.close()">{{content?.['b2b.managepolicy.save']}}</button>
    </div>
  </div>
</ng-template>